import {
    SKILL_QUESTS_MASTERY_STUDENT_REQUEST,
    SKILL_QUESTS_MASTERY_STUDENT_RETRIEVED,
    SKILL_QUESTS_MASTERY_STUDENT_COURSE_REQUEST,
    SKILL_QUESTS_MASTERY_STUDENT_COURSE_RETRIEVED,
    SKILL_QUESTS_MASTERY_STUDENT_SELECTED_COURSE,
    SKILL_QUESTS_MASTERY_STUDENT_SELECTED_CURRICULUM,
    SKILL_QUESTS_MASTERY_STUDENT_RESET,
    SKILL_QUESTS_MASTERY_IS_FILTERED
} from './student-actions';

const initialState = {
    isLoading: false,
    data: null,
    selectedCurriculum: null,
    selectedCourse: null,
    isFiltered: false
};

/**
 * Skill Quests Mastery - Student Reducer
 *
 * Consumes SKILL_QUESTS_MASTERY_STUDENT_RETRIEVED action
 *
 * @access public
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - the action's payload, or the current state if action is unhandled
 */
export default function(state = initialState, action) {
    if (!action) return state;

    switch (action.type) {
        case SKILL_QUESTS_MASTERY_STUDENT_REQUEST: {
            return {
                ...state,
                isLoading: true,
                data: null
            };
        }
        case SKILL_QUESTS_MASTERY_STUDENT_RETRIEVED:
            return {
                ...state,
                isLoading: false,
                data: action.payload
            };
        case SKILL_QUESTS_MASTERY_STUDENT_COURSE_REQUEST: {
            return {
                ...state,
                isLoading: true,
                data: {
                    ...state.data,
                    reportData: null
                }
            };
        }
        case SKILL_QUESTS_MASTERY_STUDENT_COURSE_RETRIEVED: {
            return {
                ...state,
                isLoading: false,
                data: {
                    ...state.data,
                    reportData: action.payload
                }
            };
        }
        case SKILL_QUESTS_MASTERY_STUDENT_SELECTED_CURRICULUM: {
            const { data, selected } = action.payload;

            return {
                ...state,
                selectedPublication: {
                    data,
                    selected
                }
            };
        }
        case SKILL_QUESTS_MASTERY_STUDENT_SELECTED_COURSE: {
            const { data, selected } = action.payload;

            return {
                ...state,
                selectedCourse: {
                    data,
                    selected
                }
            };
        }
        case SKILL_QUESTS_MASTERY_IS_FILTERED: {
            return {
                ...state,
                isFiltered: action.payload
            };
        }
        case SKILL_QUESTS_MASTERY_STUDENT_RESET: {
            return initialState;
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./containers/skill-quests-mastery/student/student-reducer.js